// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nQAQ","right":"styles_right__3ZVtX"};